export default __webpack_public_path__ + "static/media/refComingSoon.6757e6a8.svg";